import { useState, useCallback, useRef } from "react";
import { FlashbarProps } from "@cloudscape-design/components";
import { NotificationType, NotifyFn } from "../constants";

interface UseNotificationsReturn {
  items: FlashbarProps.MessageDefinition[];
  notify: NotifyFn;
  clear: () => void;
}

export function useNotifications(): UseNotificationsReturn {
  const [items, setItems] = useState<FlashbarProps.MessageDefinition[]>([]);
  const counterRef = useRef(0);

  const notify = useCallback((type: NotificationType, content: string) => {
    counterRef.current += 1;
    const id = `notification-${counterRef.current}`;
    setItems((prev) => [
      ...prev,
      {
        type,
        content,
        id,
        dismissible: true,
        onDismiss: () => setItems((p) => p.filter((i) => i.id !== id)),
      },
    ]);
  }, []);

  const clear = useCallback(() => setItems([]), []);

  return { items, notify, clear };
}
